import Repository from '../Repository';
import dateUtils from "@/utils/dateUtils";

export default {

	/*getFile(horaceGuid) {
		var response = Repository.get('File/GetFile', {
			params: {
				horaceGuid: horaceGuid
			}			
		});
		return response;
	},*/

	getStoredFile(horaceGuid, mimeType, filename, fileExtension) {

		var response = Repository.get('File/GetStoredFile', {
			responseType: 'arraybuffer',
            headers: {
				'Content-Type': 'application/json',
				'Accept': '*/*'
            },					
			params: {
				horaceGuid: horaceGuid,
				mimeType: mimeType,
				filename: filename,
				fileExtension: fileExtension
			}
		});
		return response;
	},

}
